//Name,Genre, BirthYear, Year of Debut Album, Number of Monthly Streams, Number of Albums
export const defaultBoard = [
    ["","",null,null,null,null],
    ["","",null,null,null,null],
    ["","",null,null,null,null],
    ["","",null,null,null,null],
    ["","",null,null,null,null],
    ["","",null,null,null,null]
]